import React from "react";
import PropTypes from "prop-types"
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import $ from "jquery";
import bsCustomFileInput from 'bs-custom-file-input'
import {IMAGE_HOST_URL} from "../../constants/ConfigFromBuildEnvironment";


class ImageUploaderView extends React.Component {

    static propTypes = {
        isDisabled: PropTypes.bool.isRequired,
        showingImageSlideIndex: PropTypes.number.isRequired,
        imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        uploadPercentage: PropTypes.number.isRequired,
        labelName: PropTypes.string.isRequired,
     };

    componentDidMount() {
        bsCustomFileInput.init();
        $('#uploadsCarousel').on('slide.bs.carousel', function (e) {
            EventPublisher.publish(UIInteractionEvents.SHOWN_IMAGE_CHANGING, {fromIndex:e.from, toIndex:e.to});
        });
        $('#uploadsCarousel').on('slid.bs.carousel', function (e) {
            EventPublisher.publish(UIInteractionEvents.SHOWN_IMAGE_CHANGE_FINISHED, {fromIndex:e.from, toIndex:e.to});
        });
    }

    handleUploadImages = (event) => {
        if (event.target.files.length !== 0) {
            EventPublisher.publish(
                UIInteractionEvents.FILE_UPLOAD_STARTED,
                {
                    "files": event.target.files
                }
            );
        }
    };

    handleImageDelete = (event) => {
        event.preventDefault();
        event.stopPropagation();
        EventPublisher.publish(
            UIInteractionEvents.DELETE_IMAGE,
            {
                "imageName": this.props.imageNames[this.props.showingImageSlideIndex]
            });
        $('#uploadsCarousel').carousel(0);
    };

    render() {
        return (

            <div className="form-group">
                <label htmlFor="inputAdvertisementImageUpload">{this.props.labelName}</label>
                <div className="input-group flex-nowrap">
                    <div id="uploadsCarousel" className="uploadsCarousel carousel slide carousel-fade w-100" data-interval="false">
                        <div className="carousel-inner">
                            {this.renderImageItems()}
                        </div>
                        {this.renderNavButtons()}
                    </div>
                    {this.renderDeleteButton()}
                </div>
                {this.renderUploadProgress()}
                <div className="custom-file">
                    <input
                        type="file"
                        className="custom-file-input"
                        id="imageUpload"
                        accept="image/png, image/jpeg"
                        multiple={true}
                        onChange={this.handleUploadImages}
                        disabled={this.props.isDisabled}
                    />
                    <label className="custom-file-label" htmlFor="imageUpload">
                        Select Images to Upload
                    </label>
                </div>
            </div>
        );
    }

    renderImageItems() {
        let imageUrlsToShow = [];
        if (this.props.imageNames.length === 0) {
            imageUrlsToShow = ["https://via.placeholder.com/300x300.png?text=Preview"];
        } else {
            for (const imageName of this.props.imageNames) {
                imageUrlsToShow.push(IMAGE_HOST_URL + imageName) ;
            }
        }
        const imageItems = [];
        for (const imageUrl of imageUrlsToShow) {
            let imageClass = "carousel-item";
            if (imageItems.length === 0) {
                imageClass += " active";
            }
            imageItems.push(
                <div className={imageClass} key={"carouselImageItem-"+imageItems.length}>
                    <img src={imageUrl} className="d-block w-100" alt="..." style={{height: "300px"}}/>
                </div>
            );
        }
        return imageItems;
    }

    renderNavButtons() {
        if (this.props.imageNames.length <= 1) {
            return null;
        }
        return (
            <span>
                <a className="carousel-control-prev" href="#uploadsCarousel" role="button" data-slide="prev">
                    <span><i className="fa fa-angle-left fa-2x" aria-hidden="true"/></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#uploadsCarousel" role="button" data-slide="next">
                    <span><i className="fa fa-angle-right fa-2x" aria-hidden="true"/></span>
                    <span className="sr-only">Next</span>
                </a>
            </span>
        );
    }

    renderDeleteButton() {
        if (this.props.imageNames.length === 0) {
            return null;
        }
        return (
            <div className="input-group-append">
                <span
                    className="input-group-text"
                    id="addon-wrapping"
                >
                    <button
                        className="btn btn-sm btn-outline-danger"
                        disabled={this.props.showingImageSlideIndex === -1 || this.props.isDisabled}
                        onClick={this.handleImageDelete}
                    >
                        <i
                            className="fas fa-trash"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Delete"
                        />
                    </button>

                </span>
            </div>
        );
    }

    renderUploadProgress() {
        if (this.props.uploadPercentage === 100) {
            return null;
        }

        return (
            <div className="progress">
                <div
                    className="progress-bar bg-success"
                    role="progressbar"
                    style={{"width": this.props.uploadPercentage+"%"}}
                    aria-valuenow={""+this.props.uploadPercentage}
                    aria-valuemin="0"
                    aria-valuemax="100"
                >
                    {this.props.uploadPercentage}%
                </div>
            </div>
        );
    }

}

export default ImageUploaderView;